import React  from "react";
import { LOGO} from 'src/assets/images/index';
import WaitRipple from "components/WaitRipple";

const Loader = () => (<div className="loader">
    <WaitRipple />
    <img className="loaderLogo" alt="loader logo" src={LOGO} />
</div>);

export default Loader;